import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

type Props = {
  color?: 'success' | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';
  variant?: 'text' | 'contained' | 'outlined';
  label: string;
  onClick: (item: string) => void;
  items: {
    value: string;
    label: string;
    help?: string;
  }[];
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
};

const VNDropdownButton = ({
  color = 'success',
  variant = 'contained',
  label,
  onClick,
  items,
  disabled,
  size = 'medium',
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (item: string) => () => {
    onClick(item);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color={color}
        variant={variant}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={anchorEl ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        disabled={disabled}
        size={size}
      >
        {label}
      </Button>

      <Menu
        className="dropdown-button-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {items.map((item) => (
          <MenuItem key={item.value} onClick={handleClick(item.value)}>
            {item.label}&nbsp;
            {item.help && <span> - {item.help}</span>}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default VNDropdownButton;
